import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// TODO: include a 'direction' prop to allow vertical and horizontal dividers

const StyledDivider = styled.div`
  border-right: 1px solid ${props => props.theme.text.text200};
  display: inline;
  width: 1px;

  /** SIZE */
  height: ${props => props.size};
`;

const Divider = forwardRef(({ className, size }, ref) => {
  return <StyledDivider className={className} size={size} ref={ref} />;
});

const dividerPropTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
};
const dividerDefaultProps = {
  className: undefined,
  size: '66%',
};

Divider.propTypes = dividerPropTypes;
Divider.defaultProps = dividerDefaultProps;
export default Divider;
export { dividerDefaultProps, dividerPropTypes };
